import { CHART_VIEWS } from './ItemAnalytics';

// Sort by options enum
export const SORT_BY = {
    RUN: 'run',
    RESTOCK: 'restock',
    TRASHED: 'trashed',
    USED: 'used',
    PICKED: 'picked',
    ALL: 'all'
};

// Sort order options enum
export const SORT_ORDER = {
    ASC: 'asc',
    DESC: 'desc'
};

// Comparator function for sorting groups by quantity
export function createQuantityComparator(sortBy = SORT_BY.ALL, sortOrder = SORT_ORDER.DESC, chartType = CHART_VIEWS.PICKLIST_VIEW) {
    return (a, b) => {
        let valueA, valueB;
        
        // Handle both object entries [key, value] and direct objects
        const objA = Array.isArray(a) ? a[1] : a;
        const objB = Array.isArray(b) ? b[1] : b;
        
        switch (sortBy) {
        case SORT_BY.RUN:
            valueA = objA.run_quantity;
            valueB = objB.run_quantity;
            break;
        case SORT_BY.RESTOCK:
            valueA = objA.restock_quantity;
            valueB = objB.restock_quantity;
            break;
        case SORT_BY.TRASHED:
            valueA = objA.trashed_quantity;
            valueB = objB.trashed_quantity;
            break;
        case SORT_BY.USED:
            valueA = objA.used_quantity;
            valueB = objB.used_quantity;
            break;
        case SORT_BY.PICKED:
            valueA = objA.picked_quantity;
            valueB = objB.picked_quantity;
            break;
        case SORT_BY.ALL:
        default:
            if (chartType === CHART_VIEWS.PICKLIST_VIEW) {
                valueA = objA.run_quantity + objA.restock_quantity + objA.trashed_quantity;
                valueB = objB.run_quantity + objB.restock_quantity + objB.trashed_quantity;
            } else {
                valueA = objA.picked_quantity + objA.used_quantity;
                valueB = objB.picked_quantity + objB.used_quantity;
            }
            break;
        }
        
        // Apply sort order
        return sortOrder === SORT_ORDER.ASC ? valueA - valueB : valueB - valueA;
    };
}

// Normalise a raw group array into a map keyed by id, adding a common `name` field
// and computing `picked_quantity` (open + hold) which createInsights relies on.
export function normalizeGroupData(arr, idField, nameField) {
    if (!Array.isArray(arr)) return {};
    return arr.reduce((acc, item) => {
        const id = item[idField];
        acc[id] = {
            ...item,
            id,
            name: item[nameField],
        };
        return acc;
    }, {});
}

export function normalizeTimeData(arr, period) {
    if (!Array.isArray(arr)) return {};
    return arr.reduce((acc, item) => {
        period = item[period];
        acc[period] = {
            ...item,
            picked_quantity: (item.open_quantity || 0) + (item.hold_quantity || 0)
        };
        return acc;
    }, {});
}